export const products = {
  attributes: [
    {
      id: 0,
      title: "Прибуток",
      restriction: 0,
      meassurement: "",
    },
  ],
  values: [
    {
      id: 0,
      title: "",
      prodValues: [{ id: 0, value: "" }],
    },
  ],
};
export const destiny = {
  attributes: [
    {
      id: 0,
      title: "1",
      restriction: 0,
      meassurement: "",
    },
    {
      id: 1,
      title: "2",
      restriction: 15,
      meassurement: "",
    },
    {
      id: 2,
      title: "3",
      restriction: 15,
      meassurement: "",
    },
    {
      id: 3,
      title: "4",
      restriction: 40,
      meassurement: "",
    },
  ],
  values: [
    {
      id: 0,
      title: "1",
      prodValues: [
        { id: 0, value: 6 },
        { id: 1, value: 6 },
        { id: 2, value: 4 },
        { id: 3, value: 5 },
      ],
    },
    {
      id: 1,
      title: "2",
      prodValues: [
        { id: 0, value: 5 },
        { id: 1, value: 1 },
        { id: 2, value: 4 },
        { id: 3, value: 2 },
      ],
    },
    {
      id: 2,
      title: "3",
      prodValues: [
        { id: 0, value: 5 },
        { id: 1, value: 2 },
        { id: 2, value: 2 },
        { id: 3, value: 8 },
      ],
    },
    {
      id: 3,
      title: "4",
      prodValues: [
        { id: 0, value: 3 },
        { id: 1, value: 7 },
        { id: 2, value: 5 },
        { id: 3, value: 3 },
      ],
    },
  ],
};
// export const destiny = {
//   attributes: [
//     {
//       id: 0,
//       title: "1",
//       restriction: 0,
//       meassurement: "",
//     },
//     {
//       id: 1,
//       title: "2",
//       restriction: 15,
//       meassurement: "",
//     },
//     {
//       id: 2,
//       title: "3",
//       restriction: 15,
//       meassurement: "",
//     },
//     {
//       id: 3,
//       title: "4",
//       restriction: 40,
//       meassurement: "",
//     },
//     {
//       id: 4,
//       title: "5",
//       restriction: 30,
//       meassurement: "",
//     },
//   ],
//   values: [
//     {
//       id: 0,
//       title: "1",
//       prodValues: [
//         { id: 0, value: 2 },
//         { id: 1, value: 1 },
//         { id: 2, value: 3 },
//         { id: 3, value: 1 },
//         { id: 4, value: 3 },
//       ],
//     },
//     {
//       id: 1,
//       title: "2",
//       prodValues: [
//         { id: 0, value: 4 },
//         { id: 1, value: 5 },
//         { id: 2, value: 5 },
//         { id: 3, value: 4 },
//         { id: 4, value: 2 },
//       ],
//     },
//     {
//       id: 2,
//       title: "3",
//       prodValues: [
//         { id: 0, value: 1 },
//         { id: 1, value: 4 },
//         { id: 2, value: 2 },
//         { id: 3, value: 3 },
//         { id: 4, value: 5 },
//       ],
//     },
//     {
//       id: 3,
//       title: "4",
//       prodValues: [
//         { id: 0, value: 3 },
//         { id: 1, value: 1 },
//         { id: 2, value: 2 },
//         { id: 3, value: 1 },
//         { id: 4, value: 3 },
//       ],
//     },
//     {
//       id: 4,
//       title: "5",
//       prodValues: [
//         { id: 0, value: 3 },
//         { id: 1, value: 2 },
//         { id: 2, value: 4 },
//         { id: 3, value: 4 },
//         { id: 4, value: 5 },
//       ],
//     },
//   ],
// };
export const transport = {
  attributes: [
    {
      id: 0,
      title: "Тут введіть потреби споживачів",
      restriction: 0,
      meassurement: "",
    },
    {
      id: 1,
      title: "A1",
      restriction: 200,
      meassurement: "",
    },
    {
      id: 2,
      title: "A2",
      restriction: 300,
      meassurement: "",
    },
    {
      id: 3,
      title: "A3",
      restriction: 150,
      meassurement: "",
    },
    {
      id: 4,
      title: "A4",
      restriction: 200,
      meassurement: "",
    },
    {
      id: 5,
      title: "A5",
      restriction: 250,
      meassurement: "",
    },
    {
      id: 6,
      title: "A6",
      restriction: 150,
      meassurement: "",
    },
    {
      id: 7,
      title: "A7",
      restriction: 250,
      meassurement: "",
    },
  ],
  values: [
    {
      id: 0,
      title: "B1",
      prodValues: [
        { id: 0, value: 100 },
        { id: 1, value: 7 },
        { id: 2, value: 8 },
        { id: 3, value: 9 },
        { id: 4, value: 4 },
        { id: 5, value: 5 },
        { id: 6, value: 6 },
        { id: 7, value: 8 },
      ],
    },
    {
      id: 1,
      title: "B2",
      prodValues: [
        { id: 0, value: 150 },
        { id: 1, value: 5 },
        { id: 2, value: 6 },
        { id: 3, value: 7 },
        { id: 4, value: 5 },
        { id: 5, value: 9 },
        { id: 6, value: 9 },
        { id: 7, value: 7 },
      ],
    },
    {
      id: 2,
      title: "B3",
      prodValues: [
        { id: 0, value: 300 },
        { id: 1, value: 8 },
        { id: 2, value: 4 },
        { id: 3, value: 5 },
        { id: 4, value: 6 },
        { id: 5, value: 7 },
        { id: 6, value: 7 },
        { id: 7, value: 5 },
      ],
    },
    {
      id: 3,
      title: "B4",
      prodValues: [
        { id: 0, value: 200 },
        { id: 1, value: 6 },
        { id: 2, value: 5 },
        { id: 3, value: 7 },
        { id: 4, value: 5 },
        { id: 5, value: 4 },
        { id: 6, value: 4 },
        { id: 7, value: 9 },
      ],
    },
    {
      id: 4,
      title: "B5",
      prodValues: [
        { id: 0, value: 150 },
        { id: 1, value: 8 },
        { id: 2, value: 6 },
        { id: 3, value: 6 },
        { id: 4, value: 6 },
        { id: 5, value: 7 },
        { id: 6, value: 8 },
        { id: 7, value: 4 },
      ],
    },
    {
      id: 5,
      title: "B6",
      prodValues: [
        { id: 0, value: 200 },
        { id: 1, value: 4 },
        { id: 2, value: 7 },
        { id: 3, value: 5 },
        { id: 4, value: 7 },
        { id: 5, value: 9 },
        { id: 6, value: 6 },
        { id: 7, value: 7 },
      ],
    },
    {
      id: 6,
      title: "B7",
      prodValues: [
        { id: 0, value: 100 },
        { id: 1, value: 5 },
        { id: 2, value: 6 },
        { id: 3, value: 8 },
        { id: 4, value: 6 },
        { id: 5, value: 7 },
        { id: 6, value: 5 },
        { id: 7, value: 9 },
      ],
    },
    {
      id: 7,
      title: "B8",
      prodValues: [
        { id: 0, value: 150 },
        { id: 1, value: 6 },
        { id: 2, value: 8 },
        { id: 3, value: 6 },
        { id: 4, value: 7 },
        { id: 5, value: 5 },
        { id: 6, value: 7 },
        { id: 7, value: 6 },
      ],
    },
  ],
};
export const inputTypes = {
  ATTRIBUTE: "attributes",
  TITLE: "title",
  VALUE: "value",
  ATTR_REST: "attribute_restriction",
  PROD_REST: "production_restriction",
};

export const signs = [
  {
    value: -1,
    sign: "<=",
    LESS_EQUALS: "less_equals",
  },
];

// const signs = [
//   {
//     value: 1,
//     sign: ">=",
//     MORE_EQUALS: "more_equals",
//   },
//   {
//     value: 0,
//     sign: "=",
//     EQUALS: "equals",
//   },
//   {
//     value: -1,
//     sign: "<=",
//     LESS_EQUALS: "less_equals",
//   },
// ];
